import React from 'react';
import { Trans } from '@lingui/react';
import { Type } from './domain/Risk';
import { Variant } from './domain/Terms';
import { PaymentRythm } from '@qover/domain';

import {
  TheftIconMixin,
  TheftAssistanceIconMixin,
  TheftDamageAssistanceIconMixin,
} from './components/BikeIcons';
import { FormattedCurrency, FormattedMarkdown } from '@qover/react-intl';

export const nextButtonMessages = {
  purchaseNow: <Trans id="bike.bottomNav.purchaseNow" />,
  payNow: <Trans id="bike.bottomNav.payNow" />,
};

// The undefined are only meant for TS_error ...
export const messagesPerVariant = {
  [Variant.VARIANT_ASSISTANCE]: {
    planName: <Trans id="bike.planName.assistance" />,
    planNameKey: 'bike.planName.assistance',
    optionIconLabel: <Trans id="bike.optionLabel.summary.assistance" />,
    optionLabel: <Trans id="bike.optionLabel.assistance" />,
    optionTitle: <Trans id="bike.optionTitle.assistance" />,
    optionContent: <Trans id="bike.optionContent.assistance" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.assistance"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.assistance.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: undefined,
    dataLayerName: 'Assistance',
    advantages: <FormattedMarkdown id="bike.summary.advantages.assistance" />,
    policyholderText: (
      <FormattedMarkdown id="bike.policyholder.text.assistance" />
    ),
  },
  [Variant.VARIANT_THEFT]: {
    planName: <Trans id="bike.planName.theft" />,
    planNameKey: 'bike.planName.theft',
    optionIconLabel: <Trans id="bike.optionLabel.summary.theft" />,
    optionLabel: <Trans id="bike.optionLabel.theft" />,
    optionTitle: <Trans id="bike.optionTitle.theft" />,
    optionContent: <Trans id="bike.optionContent.theft" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theft"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theft.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: TheftIconMixin,
    dataLayerName: 'Theft',
    advantages: <FormattedMarkdown id="bike.summary.advantages.theft" />,
    policyholderText: (
      <FormattedMarkdown id="bike.policyholder.text.theft" />
    ),
  },
  [Variant.VARIANT_THEFT_ASSISTANCE]: {
    planName: <Trans id="bike.planName.theftAssistance" />,
    planNameKey: 'bike.planName.theftAssistance',
    optionIconLabel: <Trans id="bike.optionLabel.summary.theftAssistance" />,
    optionLabel: <Trans id="bike.optionLabel.theftAssistance" />,
    optionTitle: <Trans id="bike.optionTitle.theftAssistance" />,
    optionContent: <Trans id="bike.optionContent.theftAssistance" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftAssistance"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftAssistance.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: TheftAssistanceIconMixin,
    dataLayerName: 'Theft + Assistance',
    advantages: (
      <FormattedMarkdown id="bike.summary.advantages.theftAssistance" />
    ),
    policyholderText: (
      <FormattedMarkdown id="bike.policyholder.text.theftAssistance" />
    ),
  },
  [Variant.VARIANT_THEFT_DAMAGE]: {
    planName: <Trans id="bike.planName.theftDamage" />,
    planNameKey: 'bike.planName.theftDamage',
    optionIconLabel: <Trans id="bike.optionLabel.summary.theftDamage" />,
    optionLabel: <Trans id="bike.optionLabel.theftDamage" />,
    optionTitle: <Trans id="bike.optionTitle.theftDamage" />,
    optionContent: <Trans id="bike.optionContent.theftDamage" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftDamage"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftDamage.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: TheftDamageAssistanceIconMixin,
    dataLayerName: 'Theft + Damage',
    advantages: <FormattedMarkdown id="bike.summary.advantages.theftDamage" />,
    policyholderText: (
      <FormattedMarkdown id="bike.policyholder.text.theftDamage" />
    ),
  },
  [Variant.VARIANT_THEFT_DAMAGE_ASSISTANCE]: {
    planName: <Trans id="bike.planName.theftDamageAssistance" />,
    planNameKey: 'bike.planName.theftDamageAssistance',
    optionIconLabel: (
      <Trans id="bike.optionLabel.summary.theftDamageAssistance" />
    ),
    optionLabel: <Trans id="bike.optionLabel.theftDamageAssistance" />,
    optionTitle: <Trans id="bike.optionTitle.theftDamageAssistance" />,
    optionContent: <Trans id="bike.optionContent.theftDamageAssistance" />,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftDamageAssistance"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.YEARLY]: (upsellPrice: number) => (
        <Trans
          id="bike.upsell.theftDamageAssistance.yearly"
          values={{ upsellPrice: <FormattedCurrency value={upsellPrice} /> }}
        />
      ),
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: TheftDamageAssistanceIconMixin,
    dataLayerName: 'Theft + Assistance + Damage',
    advantages: (
      <FormattedMarkdown id="bike.summary.advantages.theftDamageAssistance" />
    ),
    policyholderText: (
      <FormattedMarkdown id="bike.policyholder.text.theftDamageAssistance" />
    ),
  },
  [Variant.VARIANT_UNSPECIFIED]: {
    planName: null,
    planNameKey: '',
    optionLabel: null,
    optionIconLabel: null,
    optionTitle: null,
    optionContent: undefined,
    upsellMessage: {
      [PaymentRythm.MONTHLY]: () => undefined,
      [PaymentRythm.YEARLY]: () => undefined,
      [PaymentRythm.ONE_TIME]: () => undefined,
    },
    optionIcon: undefined,
    dataLayerName: undefined,
    advantages: undefined,
    policyholderText: undefined,
  },
};

export const messagesPerBikeType = {
  [Type.TYPE_REGULAR_BIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.regular' },
    type: { id: 'bike.quote.bike.type.regular' },
  },
  [Type.TYPE_REGULAR_EBIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.regularE' },
    type: { id: 'bike.quote.bike.type.regularE' },
  },
  [Type.TYPE_RACE_BIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.race' },
    type: { id: 'bike.quote.bike.type.race' },
  },
  [Type.TYPE_RACE_EBIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.raceE' },
    type: { id: 'bike.quote.bike.type.raceE' },
  },
  [Type.TYPE_MOUNTAIN_BIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.mountain' },
    type: { id: 'bike.quote.bike.type.mountain' },
  },
  [Type.TYPE_MOUNTAIN_EBIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.mountainE' },
    type: { id: 'bike.quote.bike.type.mountainE' },
  },
  [Type.TYPE_CARGO_BIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.cargo' },
    type: { id: 'bike.quote.bike.type.cargo' },
  },
  [Type.TYPE_CARGO_EBIKE]: {
    optionSelect: { id: 'bike.quote.bike.type.cargoE' },
    type: { id: 'bike.quote.bike.type.cargoE' },
  },
  [Type.TYPE_UNSPECIFIED]: {
    optionSelect: { id: '' },
    type: { id: '' },
  },
};
